import { render, staticRenderFns } from "./link-move-container.vue?vue&type=template&id=d67c581a&"
import script from "./link-move-container.vue?vue&type=script&lang=js&"
export * from "./link-move-container.vue?vue&type=script&lang=js&"
import style0 from "./link-move-container.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports